// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"wR-z","inlineTitle":"xR-z","sponsoredAdsWrapper":"yR-z","marketplaceRecosWrapper":"zR-z"};